<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-2"><span class="CharOverride-4">Also by Lily King</span></p>
<p class="ACTitle01">Five Tuesdays in Winter</p>
<p class="ACTitle">The Pleasing Hour</p>
<p class="ACTitle">The English Teacher</p>
<p class="ACTitle">Euphoria</p>
<p class="ACTitle">Writers &amp; Lovers</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021970851.vue?efe4ff7a